export const frag = /*glsl*/ `
precision mediump float;

uniform sampler2D tMap;
uniform vec3 uColor;
uniform float uProgress;
uniform float uCoolEffectIntensity;
uniform float uTime;

varying vec2 vUv;
varying vec3 vPosition;

#define PI 3.141592

float pow2(float x) {return x*x;}

void main(){
	vec3 color = uColor;
	float a = texture2D(tMap, vUv).r;
	a *= vUv.y * 2. * (pow2(smoothstep(-.2, 0., vPosition.z)) + .1);

	float progress = uProgress * (1. - uCoolEffectIntensity) * (-vPosition.z * .5 + 1.);

	a *= smoothstep(progress * 1.5 + .01, progress * 1.5, floor(vUv.y * 10.) * .1 + abs(floor(sin(vUv.x * 102.48 + vPosition.z * 10.) + cos(vUv.x * 18.7 - vPosition.z * 18.))) * .5);

	// a += .5;

	if(a < .001) discard;
	gl_FragColor = vec4(color, a);
}`;
